const pusherOperationEnum = Object.freeze({
  ENABLED: 'enabled',
  DISABLED: 'disabled',
  CREATED: 'created',
  UPDATED: 'updated',
  DELETED: 'deleted',
});

export default pusherOperationEnum;
